// eslint-disable-next-line jira/restricted/graphql-tag
import gqlTagGira from 'graphql-tag';

export const GET_NUMBER_CURRENCY_FORMATTING_CHANGEBOARDING_CRITIERA_QUERY = gqlTagGira`
	query getNumberCurrencyFormattingChangeboardingCriteria ($projectAri: ID!, $projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
		jira {
			jiraProject(id: $projectAri) {
				id
				projectId
				key
				name
				projectType
				tmpBoardId
				administerProject: action(type: EDIT_PROJECT_CONFIG) {
					canPerform
				}
			}
		}
		jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
			edges {
				node {
					issueType {
						issueTypeId
					}
					fields {
						edges {
							node {
								fieldId
								type
								... on JiraNumberField {
									fieldConfig {
										isRequired
										isEditable
									}
									formatConfig {
										... on JiraNumberFieldFormatConfig {
											formatStyle
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;
